module.exports = __webpack_public_path__ + "media/theme/steps--2--close-a47e0774.png";